// extracted by mini-css-extract-plugin
module.exports = {"commentWrap":"like_commentWrap__3pxt9","commentHeader":"like_commentHeader__2okiU","userWrap":"like_userWrap__SmtbP"};